import { render, staticRenderFns } from "./PageUp.vue?vue&type=template&id=a56ff5b2"
import script from "./PageUp.vue?vue&type=script&lang=js"
export * from "./PageUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports